<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Parking Fee</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" type="text" v-model="parking_fee" placeholder="Parking fee" :class="{ 'is-danger': errors.parking_fee }">
                    <span class="icon is-left">
                        <i class="fas fa-parking"></i>
                    </span>
                    <p v-if="errors.parking_fee" class="help is-danger">{{ errors.parking_fee[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            parking_fee: {
                get() {
                    return this.$store.getters.getNewPricePlan.parking_fee
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'parking_fee', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/ParkingFeeInput.vue